import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { Button } from "@mui/material";
import { QrReader } from "react-qr-reader";
import Alert from "@mui/material/Alert";
import axios from "axios";
import { getAllUsers } from "../../utils/utilsAPI";
import { decryptData } from "../../utils/cryptoUtils";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export default function QRCheck({
  assetLocations,
  refreshAssets,
  handleClose,
}) {
  const url = process.env.REACT_APP_URL;
  const [assetId, setAssetId] = useState(null);
  const [assetName, setAssetName] = useState("");
  const [assetLocation, setAssetLocation] = useState(0);
  const [checkedIn, setCheckedIn] = useState(null);
  const [forSelf, setForSelf] = useState(
    localStorage.getItem("asset") == process.env.REACT_APP_ADMIN_ID
      ? true
      : null
  );
  const [users, setUsers] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(0);
  //Alerts
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [disable, setDisable] = useState(false);

  const handleAlignment = (event, newAlignment) => {
    setForSelf(newAlignment);
  };

  useEffect(() => {
    //Get Users
    getAllUsers().then((res) => {
      let _users = res.users;
      let decryptedData = _users.map((u, i) => {
        return {
          ...u,
          email: decryptData(u.email, process.env.REACT_APP_ATT_KEY),
        };
      });

      setUsers(decryptedData);
    });
  }, []);

  const handleAlert = (message, severity, close = false, duration = 4000) => {
    setMessage(message);
    setSeverity(severity);
    setAlert(true);
    setTimeout(() => {
      setAlert(false);
      setMessage("");
      setSeverity("");
      setDisable(false);
      if (close) {
        handleClose(false);
        refreshAssets();
      }
    }, duration);
  };

  const fetchAsset = async (id) => {
    setAssetId(id);
    await axios
      .post(`${url}/assets/fetch-asset`, { assetId: id })
      .then((res) => {
        let _asset = res.data.asset;
        if (
          localStorage.getItem("access") == process.env.REACT_APP_MEDIA_ID &&
          _asset.assetType != 28
        ) {
          handleAlert("You are not authorised to check this asset", "error");
        } else if (!_asset.disabled) {
          setAssetName(_asset.assetName);
          setAssetLocation(_asset.locationId);
          setCheckedIn(_asset.checkedIn);
        } else {
          handleAlert("This asset has been disabled - contact admin", "error");
        }
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Can not find asset", "error");
      });
  };

  const handleValidation = () => {
    setDisable(true);

    if (assetId === 0 || assetId === null) {
      handleAlert("No assetId provided", "warning");
    } else if (assetLocation === 0) {
      handleAlert("Please select the assets location");
    } else if (checkedIn === null) {
      handleAlert("No check in data", "warning");
    } else if (!checkedIn) {
      handleCheckIn();
    } else if (
      localStorage.getItem("access") == process.env.REACT_APP_ADMIN_ID
    ) {
      if (forSelf === null) {
        handleAlert(
          "Please select if it is for yourself or someone else",
          "warning"
        );
      } else if (!forSelf && selectedEmployee === 0) {
        handleAlert("Please select a colleague", "warning");
      } else {
        handleCheckOut();
      }
    } else {
      handleCheckOut();
    }
  };

  const handleCheckOut = async () => {
    const reqBody = {
      currentUser: parseInt(localStorage.getItem("userId")),
      assetId: assetId,
      locationId: assetLocation,
      forSelf: forSelf,
      selectedEmployee: selectedEmployee,
    };

    await axios
      .post(`${url}/assets/check-out`, reqBody)
      .then((res) => {
        handleAlert("Asset checked out", "success", true, 500);
      })
      .catch((err) => {
        console.log(err);
        handleAlert("Could not check out asset", "error");
      });
  };

  const handleCheckIn = async () => {
    const reqBody = {
      currentUser: parseInt(localStorage.getItem("userId")),
      assetId: assetId,
      locationId: assetLocation,
    };

    await axios
      .post(`${url}/assets/check-in`, reqBody)
      .then((res) => {
        handleAlert("Asset checked in", "success", true);
      })
      .catch((err) => {
        handleAlert("Could not check in asset", "error");
      });
  };
  return (
    <Box className="qr-asset-modal">
      <section className="qr-asset-section">
        <h2>QR Scanner</h2>
        <p>Scan QR code below</p>

        <QrReader
          onResult={(result, error) => {
            if (!!result) {
              fetchAsset(result?.text);
            }
          }}
          style={{ width: "100%" }}
          className="qr-reader"
          constraints={{
            facingMode: "environment",
          }}
        />
        <section className="check-section">
          {assetId !== null ? (
            <table className="qr-table">
              <tbody>
                <tr>
                  <th>Asset ID</th>
                  <td>{assetId && assetId}</td>
                </tr>
                <tr>
                  <th>Asset Name</th>
                  <td>{assetName && assetName}</td>
                </tr>
                <tr>
                  <th>Asset Location</th>
                  <td>
                    <select
                      value={assetLocation}
                      onChange={(e) =>
                        setAssetLocation(parseInt(e.target.value))
                      }
                    >
                      <option value={0}>Select location</option>
                      {assetLocations && assetLocations.length > 0
                        ? assetLocations.map((l, i) => {
                            return (
                              <option key={i} value={l.locationId}>
                                {l.locationName}
                              </option>
                            );
                          })
                        : null}
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : null}
        </section>
        {checkedIn ? (
          <>
            {localStorage.getItem("access") ==
            process.env.REACT_APP_ADMIN_ID ? (
              <section className="admin-check-section">
                <p>
                  Are you checking this {checkedIn ? "out" : "in"} for yourself
                  or another colleague?
                </p>
                <ToggleButtonGroup
                  value={forSelf}
                  exclusive
                  onChange={handleAlignment}
                  aria-label="text alignment"
                  className="admin-btns"
                >
                  <ToggleButton value={true}> Myself</ToggleButton>
                  <ToggleButton value={false}>Someone else</ToggleButton>
                </ToggleButtonGroup>
              </section>
            ) : null}
            {!forSelf && forSelf != null ? (
              <section className="admin-select-staff">
                <p>Select who it is on behalf of</p>
                <select
                  value={selectedEmployee}
                  onChange={(e) =>
                    setSelectedEmployee(parseInt(e.target.value))
                  }
                >
                  <option value={0}>Select Employee</option>
                  {users && users.length > 0
                    ? users.map((u, i) => {
                        return (
                          <option key={i} value={u.userId}>
                            {u.userName}
                          </option>
                        );
                      })
                    : null}
                </select>
              </section>
            ) : null}
          </>
        ) : null}
        <section className="alert-section">
          {alert ? <Alert severity={severity}>{message}</Alert> : null}
        </section>
        <section className="btn-section">
          <Button
            variant="contained"
            color="error"
            onClick={() => handleClose(false)}
          >
            Close
          </Button>{" "}
          <Button
            variant="contained"
            color="success"
            disabled={
              disable ||
              assetId === 0 ||
              assetId === null ||
              checkedIn === null ||
              assetLocation === 0
            }
            onClick={handleValidation}
          >
            Check {checkedIn ? "out" : "in"}
          </Button>
        </section>
      </section>
    </Box>
  );
}
